import React from "react";
import { NavLink } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { LayoutDashboard, PlusCircle, Inbox, List, Star, Bell, Compass, TrendingUp, Truck, ClipboardList, MessageCircle, ShieldCheck, Scale, RotateCcw, BarChart3, Activity } from "lucide-react";

const clientLinks = [
  { to: "/dashboard", label: "Vue d'ensemble", icon: LayoutDashboard, end: true },
  { to: "/en-cours", label: "Courses en cours", icon: Activity },
  { to: "/requests/new", label: "Publier une demande", icon: PlusCircle },
  { to: "/requests", label: "Mes demandes", icon: List },
  { to: "/trajets-disponibles", label: "Trajets retour", icon: RotateCcw },
  { to: "/offers", label: "Offres reçues", icon: Inbox },
  { to: "/notifications", label: "Notifications", icon: Bell },
  { to: "/support", label: "Support", icon: MessageCircle },
];

const proLinks = [
  { to: "/dashboard", label: "Marketplace", icon: LayoutDashboard, end: true },
  { to: "/en-cours", label: "Courses en cours", icon: Activity },
  { to: "/missions", label: "Mes missions", icon: ClipboardList },
  { to: "/matches", label: "Matching A/R", icon: Compass },
  { to: "/pro/trajets-retour", label: "Trajets retour", icon: RotateCcw },
  { to: "/offers", label: "Mes offres", icon: Inbox },
  { to: "/rentabilite", label: "Rentabilité", icon: TrendingUp },
  { to: "/pro/conformite", label: "Conformité", icon: ShieldCheck },
  { to: "/reviews", label: "Mes avis", icon: Star },
  { to: "/notifications", label: "Notifications", icon: Bell },
  { to: "/support", label: "Support", icon: MessageCircle },
];

const adminLinks = [
  { to: "/dashboard", label: "Dashboard", icon: LayoutDashboard, end: true },
  { to: "/admin/support", label: "Support clients", icon: MessageCircle },
  { to: "/admin/documents", label: "Documents pros", icon: ShieldCheck },
  { to: "/admin/disputes", label: "Litiges", icon: Scale },
  { to: "/admin/kpis", label: "Indicateurs", icon: BarChart3 },
  { to: "/notifications", label: "Notifications", icon: Bell },
];

export default function Sidebar() {
  const { user } = useAuth();
  const links = user?.role === "admin" ? adminLinks : user?.role === "pro" ? proLinks : clientLinks;

  return (
    <aside className="hidden lg:flex w-64 shrink-0 flex-col bg-slate-900 text-white border-r border-slate-800 min-h-[calc(100vh-4rem)] sticky top-16">
      <div className="px-6 py-6 border-b border-slate-800">
        <div className="text-[10px] uppercase tracking-[0.2em] text-orange-400 font-bold mb-1">
          {user?.role === "pro" ? "Espace dépanneur" : "Espace client"}
        </div>
        <div className="font-display font-bold text-base leading-tight truncate">{user?.name}</div>
        <div className="text-xs text-slate-400 truncate">{user?.email}</div>
      </div>
      <nav className="flex-1 px-3 py-4 space-y-1">
        {links.map(({ to, label, icon: Icon, end }) => (
          <NavLink
            key={to}
            to={to}
            end={end}
            data-testid={`sidebar-${label.toLowerCase().replace(/\s+/g, "-")}`}
            className={({ isActive }) =>
              `flex items-center gap-3 rounded-md px-3 py-2 text-sm font-medium transition-colors ${
                isActive ? "bg-orange-600 text-white" : "text-slate-300 hover:bg-slate-800 hover:text-white"
              }`
            }
          >
            <Icon className="h-4 w-4" />
            {label}
          </NavLink>
        ))}
      </nav>
      <div className="p-4 border-t border-slate-800 text-[11px] text-slate-400 flex items-center gap-2">
        <Truck className="h-3.5 w-3.5 text-orange-400" />
        FR · BE · ES · DE
      </div>
    </aside>
  );
}
